import React from "react";
import Chart from "react-apexcharts";
import ChartCard from "./ChartCard";
import { baseChartOptions, PALETTE } from "./chartTheme";

interface CasesByWeekChartProps {
  data?: number[];
  categories?: string[];
}

const CHART_ID = "cases-by-week";

const CasesByWeekChart: React.FC<CasesByWeekChartProps> = ({
  data = [],
  categories = [],
}) => {
  const safeCategories = categories.length > 0 ? categories : ["Week 1"];
  const safeData = data.length > 0 ? data : [0];

  const base = baseChartOptions(CHART_ID);
  const options = {
    ...base,
    chart: { ...base.chart, type: "area" },
    colors: [PALETTE[1]],
    xaxis: { categories: safeCategories },
    stroke: { curve: "smooth", width: 3 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 0.3, opacityFrom: 0.35, opacityTo: 0.02 },
    },
  };

  const series = [{ name: "Total Cases", data: safeData }];

  return (
    <ChartCard
      title="Total Cases by Week"
      description="Displays the number of new cases created each week."
      chartId={CHART_ID}
    >
      <Chart options={options} series={series} type="area" height={300} />
    </ChartCard>
  );
};

export default CasesByWeekChart;
